export enum BestEnrollmentType {
    Enrolled = 'Active',
    Queued = 'Pending',
    Rejected = 'Rejected'
}
(BestEnrollmentType as any)['Enrolled'] = 'Active';
(BestEnrollmentType as any)['Queued'] = 'Pending';
(BestEnrollmentType as any)['Rejected'] = 'Rejected';